<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    color="bg_Greeny_Gray"
    dark
    app
    class="elevation-2 side-nav-drawer"
    :width="300"
    :fixed="$vuetify.breakpoint.mobile"
    :permanent="!$vuetify.breakpoint.mobile"
    :temporary="$vuetify.breakpoint.mobile">
    <div class="navToggler">
      <v-img class="upper" v-if="$vuetify.theme.dark" src="@public/img/Up_Dark.svg"></v-img>
      <v-img class="upper" v-else src="@public/img/Up.svg"></v-img>
      <v-img class="lower" v-if="$vuetify.theme.dark" src="@public/img/Down_Dark.svg"></v-img>
      <v-img class="lower" v-else src="@public/img/Down.svg"></v-img>
      <v-btn class="miniToggle" dark icon depressed :ripple="false" @click.stop="onClickToggler">
        <v-icon color="grey" v-if="!mini">mdi-chevron-left</v-icon>
        <v-icon color="grey" v-else>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <!-- Logo removed - AVA logo is now in the top navigation bar -->
    <div class="px-0 darken-4 d-flex flex-column justify-center align-center">
      <v-divider style="background-color: var(--v-grey-base)"></v-divider>
      <div class="d-flex px-1 align-center">
        <user-avatar
          v-if="mini"
          :user="user"
          disable-open-link
          hide-roles
          no-tooltip
          icon></user-avatar>
        <user-profile-card v-else></user-profile-card>
        <v-btn small icon v-if="!mini" @click="showNotifications = true"
          ><v-icon small color="grey">mdi-bell-outline</v-icon></v-btn
        >
        <!-- Product release notes, sitting with the bell: both answer "what changed", and
             neither belongs in the nav list below, which is workspace resources. -->
        <v-tooltip bottom v-if="!mini">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon v-bind="attrs" v-on="on" @click="openWhatsNew">
              <v-icon small color="grey">mdi-bullhorn-outline</v-icon>
            </v-btn>
          </template>
          <span>What's New</span>
        </v-tooltip>
      </div>
      <v-divider style="background-color: var(--v-grey-base)"></v-divider>
    </div>

    <div class="px-2" v-if="showNotifications" style="height: 77vh">
      <system-notifications
        :isMenuClosed="menuClosed"
        :insideNav="true"
        @showNotifications="handleShowNotifications($event)"></system-notifications>
    </div>

    <v-list v-else class="main-nav-list pt-0 overflow-x-hidden">
      <v-list-item-group active-class="active-list-item" v-model="selectedRoute" mandatory>
        <template v-for="(item, k) in menu">
          <v-subheader
            class="menu-sub-header font-weight-bold"
            style="color: var(--v-grey-base)"
            :key="k + 'header'"
            :disabled="!$has( item.roles)"
            v-if="item.header && (item.isAdmin ? isAdmin : true)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="grey" v-bind="attrs" v-on="on"> {{ item.icon }} </v-icon>
              </template>
              <span>{{ item.header }}</span>
            </v-tooltip>

            <span class="mx-2" v-if="!mini">{{ item.header }}</span>
          </v-subheader>
          <template v-else-if="!mini">
            <v-tooltip right :key="item.title">
                  <template v-slot:activator="{ on, attrs }">
            <span  v-bind="attrs"
            v-on="on">
              <v-list-item
              v-if="item.isAdmin ? isAdmin : true"
             :disabled="!$has( item.roles)"
              :key="k"
              :ripple="false"
              :to="item.path"
              :target="item.target"
              class="ps-5"
              :class="{
                'v-item--active v-list-item--active': $route.query.selectedPageTitle === item.title,
              }"
              @click="handleClick(item)"
              style="min-height: 40px !important">
              <v-list-item-icon class="mr-2 justify-center my-2 align-self-center">
                <v-icon
                  small
                  :style="{
                    'opacity-54': !$route.path.startsWith(item.path),
                  }"
                  >{{ item.icon }}</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content class="py-1">
                <v-list-item-title class="custom-list-item-title">
                  <span :class="{'text--disabled':!$has(item.roles)}">   {{
                  item.title
                }} </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            </span>
                  </template>
                  <span>  {{ $has(item.roles)? item.title:'Permission Required' }} </span>
                </v-tooltip>
          </template>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // import version from '@Share/components/Version.vue';
  import UserProfileCard from '@Share/components/UserProfileCard.vue';
  import permissions from '../config/permissions';
  import config from '@/../appConfig';
  import { mapGetters } from 'vuex';
  import UserAvatar from '@Share/components/UserAvatar.vue';
  import SystemNotifications from '@Share/components/SystemNotifications.vue';
import { $has } from '@/utils';
import { getThemedLogo } from '@Share/config/logos';
import { isAnyViewerOpen } from '@/scripts/js/forgeviewer';

  export default {
    computed: {
      ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
      }),
      drawer: {
        get() {
          return this.$store.getters['GENERAL/GET_DRAWER'];
        },
        set(val) {
          return this.$store.commit('GENERAL/SET_DRAWER', val);
        },
      },
      isAdmin() {
        return this.$store.getters['ACCOUNT/IS_ADMIN'];
      },

      selectedProject() {
        return this.$store.getters['FACILITY/GET_FACILITY'];
      },
      sidebarLogo() {
        return getThemedLogo('ava', this.$vuetify.theme.dark);
      },
    },
    data() {
      return {
        selectedRoute: null,
        mini: false,
        permissions,
        showNotifications: false,
        menu: {
          account: {
            roles: [permissions.Users.View, permissions.Roles.View],
            header: 'Account',
            icon: 'mdi-account-outline',
          },
          userAccount: {
            title: 'Your Account',
            path: `/users/${this.$store.getters['ACCOUNT/GET_USER'].id}`,
            icon: 'mdi-account-outline',
            opened: false,
            roles: [permissions.Users.View],
            isAdmin: false,
          },
          CompanyProfile: {
            title: 'Company Profile',
            path: `/profile`,
            icon: 'mdi-office-building-outline',
            opened: false,
            roles: [permissions.Users.View],
            isAdmin: false,
          },
          ssoSettings: {
            title: 'SSO Settings',
            path: '/sso-settings',
            icon: 'mdi-shield-key-outline',
            opened: false,
            roles: [permissions.CompanyProfile.SsoSettings],
            isAdmin: false,
          },
          apiKeys: {
            title: 'API Keys',
            path: '/api-keys',
            icon: 'mdi-key-outline',
            opened: false,
            roles: [permissions.CompanyProfile.ApiKeys],
            isAdmin: false,
          },
          preferences: {
            title: 'Preferences',
            path: '/preferences',
            icon: 'mdi-cog-outline',
            opened: false,
            roles: ['All'],
            isAdmin: false,
          },
          // StorageSettings: {
          //   title: 'Storage Settings',
          //   path: '/storage-settings',
          //   icon: 'mdi-database',
          //   opened: false,
          //   roles: [permissions.CompaniesManagement.StorageSettings],
          //   isAdmin: false,
          // },
          RolesAndUsers: {
            roles: [permissions.Users.View, permissions.Roles.View],
            header: 'Users & Roles',
            icon: 'mdi-account-lock-outline',
          },

          users: {
            title: 'Users',
            path: '/users',
            icon: 'mdi-account-cog-outline',
            opened: false,
            roles: [permissions.Users.View],
            isAdmin: false,
          },
          roles: {
            title: 'Roles',
            path: '/roles',
            icon: 'mdi-crown-outline',
            opened: false,
            roles: [permissions.Roles.View],
            isAdmin: false,
          },

          MANAGEMENT: {
            header: 'Management',
            isAdmin: false,
            roles: [permissions.CompaniesManagement.View],
            icon: 'mdi-account-cog-outline',
          },

          companies: {
            title: 'Companies',
            path: '/manage-companies',
            icon: 'mdi-office-building-outline',
            opened: false,
            roles: [permissions.CompaniesManagement.View],
            isAdmin: true,
          },

          // Management-only (AVA-349). The nav entry is hidden rather than
          // disabled: the API gate is HasManagementPermission (permission AND a
          // management email domain), so a tenant user holding CompaniesManagement
          // would be rejected there anyway and should never see the door.
          feedback: {
            title: 'Feedback',
            path: '/manage-feedback',
            icon: 'mdi-star-outline',
            opened: false,
            roles: [permissions.CompaniesManagement.View],
            isAdmin: true
          },
          // Authoring side of release notes — management-only, hidden rather than
          // disabled for the same reason as Feedback above. Tenant users read the
          // published notes at /releases via "What's New" in the top navigation bar.
          releaseNotes: {
            title: 'Release Notes',
            path: '/manage-release-notes',
            icon: 'mdi-bullhorn-outline',
            opened: false,
            roles: [permissions.ReleaseNotes.View],
            isAdmin: true
          },
           pointCloudUtility: {
            title: 'Point Cloud Utility',
            path: `/pointCloudUtility`,
            icon: 'mdi-cloud-download',
            opened: false,
            roles: [permissions.CompaniesManagement.Update],
            isAdmin: true,
          },

          contractors: {
            title: 'Contractors',
            path: '/manage-contractors',
            icon: 'mdi-account-outline',
            opened: false,
            roles: [permissions.Contractors.View],
            isAdmin: false,
          },

          facilities: {
            header: 'Facilities',
            icon: 'mdi-domain',
          },

          groups: {
            title: 'Groups',
            path: '/manage-facilities-groups',
            icon: 'mdi-group',
            opened: false,
            roles: [permissions.Facilities.View],
            isAdmin: false,
          },

          imports: {
            header: 'Imports',
            icon: 'mdi-file-import',
            roles: [permissions.Registers.View],
          },

          registers: {
            title: 'Registers',
            path: '/manage-registers',
            icon: 'mdi-clipboard-list',
            opened: false,
            roles: [permissions.Registers.View],
            isAdmin: false,
          },

          // Composite Sources (AVA-487), placed directly beside Register Management.
          // Spread-omitted when the flag is off rather than marked hidden: an entry's shape
          // here is {title, path, icon, opened, roles, isAdmin} and the list renders whatever
          // this object holds, so absence is the only way to hide one.
          // The group header's own `roles` array is deliberately NOT widened — `$has` ANDs by
          // default (src/utils/index.js:8-24), so adding a key there would disable the header
          // for every existing admin who lacks it. The header only ever greys out; it never
          // gates what renders beneath it (:57), so a DataSources-only curator sees a greyed
          // header with this entry enabled under it.
          ...(config.compositeSourceBuilder === 'enabled'
            ? {
                compositeSources: {
                  title: 'Composite Sources',
                  path: '/composite-sources',
                  icon: 'mdi-table-merge-cells',
                  opened: false,
                  roles: [permissions.DataSources.View],
                  isAdmin: false,
                },
              }
            : {}),

          masters: {
            title: 'Masters',
            path: '/manage-masters',
            icon: 'mdi-database-import',
            opened: false,
            roles: [permissions.Tags.Masters.View],
            isAdmin: false,
          },

          tasks: {
            title: 'Tasks',
            path: '/manage-task-imports',
            icon: 'mdi-clipboard-arrow-up',
            opened: false,
            roles: [permissions.TaskImport.View],
            isAdmin: false,
          },

          documents: {
            title: 'Documents',
            path: '/manage-document-imports',
            icon: 'mdi-file-document-multiple',
            opened: false,
            roles: [permissions.Documents.Upload],
            isAdmin: false,
          },
        },
      };
    },
    methods: {
      $has,
      closeFacility() {
        this.$dialog.error({
          text: 'Are You Sure You Want to Close This Facility?',
          title: 'Close Facility',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.$router.replace('/');
                this.$store.commit('FACILITY/SET_FACILITY', null);
              },
            },
          },
        });
      },
      handleClick(item) {
        // this.$router.push({ query: { selectedPageTitle: item.title } });
      },
      handleShowNotifications(event) {
        this.showNotifications = event;
      },
      onClickToggler() {
        if (this.isDisplaySettingsVisible) {
          this.isDisplaySettingsVisible = false;
        }
        this.mini = !this.mini;
      },
      openWhatsNew() {
        if (this.$route.name === 'releases') return;

        // Pushed rather than replaced: the changelog is a side trip, so the page the reader came
        // from stays on the back stack. Leaving it tears down an open viewer, hence the confirm.
        const navigate = () => this.$router.push({ name: 'releases' });
        if (isAnyViewerOpen()) {
          this.$dialog.warning({
            text: 'You have a viewer open. Navigating away will close it. Are you sure you want to continue?',
            title: 'Close Viewer',
            actions: {
              false: 'Cancel',
              true: {
                text: 'Continue',
                color: 'primary',
                handle: navigate,
              },
            },
          });
        } else {
          navigate();
        }
      },
      handleLogoClicked() {
        if (isAnyViewerOpen()) {
          this.$dialog.warning({
            text: 'You have a viewer open. Navigating away will close it. Are you sure you want to continue?',
            title: 'Close Viewer',
            actions: {
              false: 'Cancel',
              true: {
                text: 'Continue',
                color: 'primary',
                handle: () => {
                  this.$router.replace('/');
                },
              },
            },
          });
        } else {
          this.$router.replace('/');
        }
      },
    },
    components: {
      // version,
      UserProfileCard,
      UserAvatar,
      SystemNotifications,
    },
  };
</script>

<style lang="scss">
  $navigation-drawer-border-width: 0px !important;
  //pl-5 pt-6 pb-2
  .menu-sub-header {
    padding: 1.5rem 0rem 1rem 1rem;
    height: 40px;
  }

  .collapser {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    top: 2.5rem;
    position: fixed;
    left: calc(220px - 24px / 2);
    background: var(--v-grey-base);
    box-shadow: var(--ds-shadow-3);
    border-radius: 1rem;
    z-index: 100;
    transition: all 0.15s ease-out;
    cursor: pointer;

    &:hover {
      background: var(--v-primary-base);
      i {
        transition: all 0.15s ease-out;
        color: var(--v-white-base);
      }
    }

    img {
      width: 0;
      height: 0;
      object-fit: contain;
      transform: scale(0);
      padding-top: 0;
      margin-right: 0;
      transition: all 0.15s ease-out;
    }

    &.closed {
      top: 3rem;
      left: -2px;
      width: 58px;
      height: 36px;
      background: var(--v-primary-base);
      border-radius: 0 0.5rem 0.5rem 0;
      border: 2px solid #fff;
      padding-right: 8px;

      i {
        transform: rotate(180deg);
      }

      img {
        transform: scale(1);
        padding-top: 2px;
        margin-right: 2px;
        margin-left: 4px;
        width: 20px;
        height: 20px;
      }
      &.small-collapse {
        width: 32px;
        height: 32px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .side-nav-drawer {
    z-index: 99;
    border-radius: 0px 16px 0px 0px;
    .navToggler {
      position: absolute;
      right: -34px;
      top: 50%;
      width: 39px;
      height: 114px;
      background-color: var(--v-bg_Greeny_Gray-base);
      display: flex;
      align-items: center;
      .upper {
        position: absolute;
        top: -27px;
        width: 40px;
      }
      .lower {
        position: absolute;
        bottom: -27px;
        width: 40px;
      }
    }

    .v-navigation-drawer__border {
      display: none !important;
    }

    .v-navigation-drawer__content {
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .main-nav-list {
      overflow: overlay;
      height: 100%;
      flex: 1 1 auto;
    }

    .v-list-item__icon {
      display: flex;
      align-items: center;
    }
    .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
      color: rgb(255 255 255 / 87%);
    }
  }

  .logo-wrapper {
    background: rgba(#090d0f, 0.04);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;

    &.dev-env {
      background: rgba(var(--v-primary-base), 0.16);
    }

    &.test-env {
      background: rgba(var(--v-error-base), 0.16);
    }
  }

  .custom-list-item-title {
    font-weight: 400;
    font-size: 13px !important;
    letter-spacing: 1.07px;
    text-indent: 1.07px;
    color: var(--v-grey-base) !important;
  }

  .active-list-item:not(.v-list-group__header):not(.v-list-group) {
    background-image: linear-gradient(
      to right,
      rgba(var(--v-primary-base), 0.1),
      rgba(var(--v-primary-base), 0.08),
      rgba(var(--v-primary-base), 0.06),
      rgba(var(--v-primary-base), 0.04),
      rgba(var(--v-primary-base), 0.02),
      rgba(var(--v-primary-base), 0.01),
      transparent,
      transparent,
      transparent
    );

    & > .v-list-item__icon {
      display: flex;
      align-items: center;
    }

    & > .v-list-item__icon > i,
    & > .v-list-item__icon > .v-icon {
      color: #fff !important;
      color: var(--v-primary-base) !important;
    }

    & > .v-list-item__content > .custom-list-item-title {
      font-weight: 400;
      color: #fff;
      color: var(--v-primary-base) !important;
    }

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      left: 0px;
      top: 8px;
      height: calc(100% - 16px);
      min-height: unset !important;
      width: 3px;
      border-radius: 0 6px 6px 0;
      background: var(--v-primary-base);
      opacity: 1;
    }
    &.sub {
      border-radius: 6px 0px 0px 6px;
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        left: 0px;
        top: 50%;
        height: 14px;
        transform: translateY(-50%);
        min-height: unset !important;
        width: 8px;
        border-radius: 1px 4px 4px 1px;
        background: var(--v-primary-base);
      }
    }

    &::before {
      display: none;
    }
  }
  .v-list-item.sub.v-list-item--link {
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      left: 0px;
      top: 50%;
      height: 14px;
      transform: translateY(-50%);
      min-height: unset !important;
      width: 8px;
      border-radius: 1px 4px 4px 1px;
      background: rgb(255 255 255 / 28%);
      opacity: 1;
    }
    &::before {
      content: '';
      display: inline-block !important;
      position: absolute;
      left: -10px;
      top: 50%;
      height: 1px;
      transform: translateY(-50%);
      min-height: unset !important;
      width: 10px;
      background-color: rgb(255 255 255 / 28%) !important;
      opacity: 1;
    }
  }

  .v-list-item-all-wrapper {
    position: relative;
  }
  .v-list-item-all-wrapper::before {
    content: '';
    position: absolute;
    left: 9px;
    width: 1px;
    height: calc(100% - 19px);
    background-color: rgba(255, 255, 255, 0.28) !important;
  }

  .v-application--is-ltr
    .v-list-group--no-action
    > .v-list-group__items
    > .v-list-item-wrapper
    > .v-list-item {
    padding-left: 48px !important;
  }

  .v-navigation-drawer--mini-variant .v-list-group--no-action .v-list-group__items,
  .v-navigation-drawer--mini-variant .v-list-group--sub-group {
    display: block !important;

    .v-list-item-wrapper > .v-list-item {
      padding-left: 16px !important;
    }
  }

  // .v-navigation-drawer {
  //   height: 96vh !important;
  //   top: 38px !important;
  // }
</style>
